import script from "./CallFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./CallFrame.vue?vue&type=script&setup=true&lang=js"

import "./CallFrame.vue?vue&type=style&index=0&id=2fef5854&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fef5854"]])

export default __exports__